export default __webpack_public_path__ + "static/media/Recommend.c1171746.jpg";